import React from 'react';

import EditIcon from 'Assets/icons/edit.svg';

export default function GeneralRiskProbabilitiesTableRow(props) {
    return (
        <tr>
            <td className="tw-align-top inbud-numeric-cell">{props.probability.percentage}%</td>
            <td className="tw-align-top">{props.probability.mark}</td>
            <td onClick={props.onEdit}>{props.probability.description}</td>
            <td>
                <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue" onClick={props.onEdit}>
                    <EditIcon />
                    <div>{$t('Edit')}</div>
                </button>
            </td>
        </tr>
    );
}
